import { useSearchParams } from 'react-router'

import { DrawerWithCloseButton } from '@/components/ui/drawer'
import { SalesLeadDetail } from './SalesLeadDetail'

// Right-side lead drawer opened from the comms bar's "Show details" on an
// incoming call. Driven by the `call_lead` URL param so it works on any internal
// page (its own param, distinct from the pipeline board's `lead`). Same
// SalesLeadDetail as the pipeline drawer; its useSalesLead(2s) keeps it fresh.
export function CallLeadDrawer() {
  const [searchParams, setSearchParams] = useSearchParams()
  const leadId = searchParams.get('call_lead')

  function close() {
    const next = new URLSearchParams(searchParams)
    next.delete('call_lead')
    setSearchParams(next, { replace: true })
  }

  return (
    <DrawerWithCloseButton
      open={!!leadId}
      onOpenChange={(open) => !open && close()}
      handleClose={close}
      title="Lead details"
      className="w-[95vw]! sm:max-w-[1400px]!"
    >
      {leadId && <SalesLeadDetail leadId={leadId} onClose={close} />}
    </DrawerWithCloseButton>
  )
}
